import Vue from 'vue'
import VeeValidate from 'vee-validate'

import Button from '../components/edgewise/Button'
import ButtonGroup from '../components/edgewise/ButtonGroup'
import ContentEditable from '../components/edgewise/ContentEditable'
import FormField from '../components/edgewise/FormField'
import Modal from '../components/edgewise/Modal'
import PhoneInput from '../components/edgewise/PhoneInput'
import RadioGroup from '../components/edgewise/RadioGroup'
import Select from '../components/edgewise/Select'
import TextArea from '../components/edgewise/TextArea'
import UOM from '../components/edgewise/UOM'

Vue.use(VeeValidate, { inject: false })

require('../filters')

Vue.component('ewr-button', Button)
Vue.component('ewr-button-group', ButtonGroup)
Vue.component('ewr-content-editable', ContentEditable)
Vue.component('ewr-form-field', FormField)
Vue.component('ewr-modal', Modal)
Vue.component('ewr-phone-input', PhoneInput)
Vue.component('ewr-radio-group', RadioGroup)
Vue.component('ewr-select', Select)
Vue.component('ewr-textarea', TextArea)
Vue.component('ewr-uom', UOM)

export default {
  data: () => ({
    mutationObserver: null
  }),

  /**
   * Lifecycle hook: mounted
   */
  mounted() {
    this._loadFonts()
    this._maybeAddMutationObserver()
  },

  /**
   * Lifecycle hook: beforeDestroy
   */
  beforeDestroy() {
    if (this.mutationObserver) {
      this.mutationObserver.disconnect()
    }
  },

  methods: {
    /**
     * Load the necessary fonts.
     * Chrome doesn't support @font-face in shadowdom, so we manually load
     * via JS and add to the body.
     */
    async _loadFonts() {
      const font = new FontFace(
        'edgewise-icons',
        'url(https://cdn.edgewiserealty.com/fonts/edgewise-icons/v1/edgewise-icons.woff)',
        {}
      )

      // wait for font to be loaded
      await font.load()

      // add font to document
      document.fonts.add(font)
    },

    /**
     * If the component theme is `squarespace`, we listen for changes to the
     * components DOM children. On any changes, we add the
     * `sqs-button-element--primary` to all buttons.
     */
    _maybeAddMutationObserver() {
      if (this.theme === 'squarespace') {
        const observerCallback = (mutationList, _observer) => {
          for (const mutation of mutationList) {
            if (mutation.type === 'childList') {
              // child node has been added or removed
              this._addSquareSpaceButtonClass()
            }
          }
        }

        // Create an observer instance linked to the callback function
        this.mutationObserver = new MutationObserver(observerCallback)

        // Start observing the target node
        this.mutationObserver.observe(this.$el, {
          childList: true,
          subtree: true
        })
      }
    },

    /**
     * Add the `sqs-button-element--primary` class to all child buttons.
     *
     * We do this because SquareSpace doesn't use CSS variables for some button
     * styles (eg, border radius and border width). The only way to have these
     * styles apply to our buttons is to add the SquareSpace classes to our buttons.
     *
     * NOTE, this will only work for SDK created components. WebComponents
     * do not adopt parent styles (shadow DOM encapsulation).
     */
    _addSquareSpaceButtonClass() {
      const primaryButtonElements = this.$el.querySelectorAll('.button')

      Array.prototype.forEach.call(primaryButtonElements, (el) => {
        el.classList.add('sqs-button-element--primary')
      })

      const secondaryButtonElements = this.$el.querySelectorAll(
        '.ewr-button-group .button'
      )

      Array.prototype.forEach.call(secondaryButtonElements, (el) => {
        el.classList.remove('sqs-button-element--primary')
        el.classList.add('sqs-button-element--secondary')
      })
    }
  }
}
